import Vue from 'vue';
import store from '../store';
import VueRouter from 'vue-router';
import Dashboard from '../views/Dashboard';
import Profile from '../views/Profile';
import Login from '../views/Login';
import MovieMapping from "../views/MovieMapping";
import MovieMappingUnknown from "../views/MovieMappingUnknown";
import MovieMappingRemap from "../views/MovieMappingRemap";
import Settings from "../views/Settings";
import Logs from "../views/Logs";
import Admin from "../views/Admin";
import PlaylistsBase from "../views/PlaylistsBase";
import PlaylistAvailablePings from "../views/PlaylistAvailablePings";
import PlaylistConfirmations from "../views/PlaylistConfirmations";
import Sessions from "../views/Sessions";
import SessionsByLineup from "../views/SessionsByLineup";
import Playlists from "../views/Playlists";
import PlaylistSessionMatch from "../views/PlaylistSessionMatch.vue";
import AdmissionsIndex from "../views/Admissions/AdmissionsIndex";
import AdmissionsByDay from "../views/Admissions/AdmissionsByDay";
import AdmissionsByWeek from "../views/Admissions/AdmissionsByWeek";
import AdmissionsByYear from "../views/Admissions/AdmissionsByYear";
import AdmissionsYearWeeks from "../views/Admissions/AdmissionsYearWeeks";
import AdmissionsYearWeekSites from "../views/Admissions/AdmissionsYearWeekSites";
import AdmissionsCinemas from "../views/Admissions/AdmissionsCinemas";
import AdmissionsCinemaYears from "../views/Admissions/AdmissionsCinemaYears";
import AdmissionsCinemaYear from "../views/Admissions/AdmissionsCinemaYear";
import AdmissionsMovieTagYears from '../views/Admissions/AdmissionsMovieTagYears';
import AdmissionsMovieTagYear from '../views/Admissions/AdmissionsMovieTagYear';
import AdmissionsMovieYears from '../views/Admissions/AdmissionsMovieYears';
import AdmissionsMovieYear from '../views/Admissions/AdmissionsMovieYear';
import AdmissionsMovie from '../views/Admissions/AdmissionsMovie';
import AdmissionsSources from '../views/Admissions/AdmissionsSources';
import AdmissionsSource from '../views/Admissions/AdmissionsSource';
import AdmissionsSync from '../views/Admissions/AdmissionsSync';
import History from "../views/History";
import HistorySearch from "../views/HistorySearch";
import HistoryDetail from "../views/HistoryDetail";
import HistoryMonthly from "../views/HistoryMonthly";
import HistoryMonthDetail from "../views/HistoryMonthDetail";

Vue.use(VueRouter);

const
    manageSettingsMeta = {
        stargateAuth: true,
        abilities: ['manage_settings']
    },
    router = new VueRouter({
        mode: 'history',
        fallback: false,
        //scrollBehavior: () => ({y: 0}),
        routes: [
            {
                path: '/',
                redirect: () => !Vue.prototype.$user ? '/login' : '/dashboard'
            },
            {
                path: '/dashboard',
                name: 'Dashboard',
                component: Dashboard,
                meta: manageSettingsMeta,
            },
            {
                path: '/sessions',
                component: Sessions,
                children: [
                    {
                        path: '',
                        name: 'SessionsByLineup',
                        component: SessionsByLineup,
                        alias: ['/sessions'],
                        meta: manageSettingsMeta,
                    },
                ],
            },
            {
                path: '/sessions/:id/playlists',
                component: PlaylistSessionMatch,
                meta: manageSettingsMeta,
            },
            {
                path: '/movie-mapping',
                component: MovieMapping,
                children: [
                    {
                        path: '',
                        name: 'MovieMappingUnknown',
                        component: MovieMappingUnknown,
                        alias: ['/movie-mapping'],
                        meta: manageSettingsMeta,
                    },
                    {
                        path: '/movie-mapping/remap',
                        name: 'MovieMappingRemap',
                        component: MovieMappingRemap,
                        meta: manageSettingsMeta,
                    },
                ],
            },
            {
                path: '/playlists',
                component: PlaylistsBase,
                children: [
                    {
                        path: '',
                        name: 'Playlists',
                        component: Playlists,
                        alias: ['/playlists'],
                        meta: manageSettingsMeta,
                    },
                    {
                        path: '/playlists/pings',
                        name: 'PlaylistAvailablePings',
                        component: PlaylistAvailablePings,
                        meta: manageSettingsMeta,
                    },
                    {
                        path: '/playlists/confirmations',
                        name: 'PlaylistConfirmations',
                        component: PlaylistConfirmations,
                        meta: manageSettingsMeta,
                    },
                ],
            },
            {
                path: '/admissions',
                component: AdmissionsIndex,
                children: [
                    {
                        path: '',
                        redirect: '/admissions/week',
                    },
                    {
                        path: 'day',
                        name: 'AdmissionsByDay',
                        component: AdmissionsByDay,
                        meta: manageSettingsMeta,
                    },
                    {
                        path: 'week',
                        name: 'AdmissionsByWeek',
                        component: AdmissionsByWeek,
                        meta: manageSettingsMeta,
                    },
                    {
                        path: 'year',
                        name: 'AdmissionsByYear',
                        component: AdmissionsByYear,
                        meta: manageSettingsMeta,
                    },
                    {
                        path: 'year/:year',
                        name: 'AdmissionsYearWeeks',
                        component: AdmissionsYearWeeks,
                        props: true,
                        meta: manageSettingsMeta,
                    },
                    {
                        path: 'year/:year/:weekCode',
                        name: 'AdmissionsYearWeekSites',
                        component: AdmissionsYearWeekSites,
                        props: true,
                        meta: manageSettingsMeta,
                    },
                    {
                        path: 'cinema',
                        name: 'AdmissionsCinemas',
                        component: AdmissionsCinemas,
                        meta: manageSettingsMeta,
                    },
                    {
                        path: 'cinema/:theatreCode',
                        name: 'AdmissionsCinemaYears',
                        component: AdmissionsCinemaYears,
                        props: true,
                        meta: manageSettingsMeta,
                    },
                    {
                        path: 'cinema/:theatreCode/:year(\\d{4})',
                        name: 'AdmissionsCinemaYear',
                        component: AdmissionsCinemaYear,
                        props: true,
                        meta: manageSettingsMeta,
                    },
                    {
                        path: 'movie-tag',
                        name: 'AdmissionsMovieTagYears',
                        component: AdmissionsMovieTagYears,
                        meta: manageSettingsMeta,
                    },
                    {
                        path: 'movie-tag/:year(\\d{4})',
                        name: 'AdmissionsMovieTagYear',
                        component: AdmissionsMovieTagYear,
                        props: true,
                        meta: manageSettingsMeta,
                    },
                    {
                        path: 'movie',
                        name: 'AdmissionsMovieYears',
                        component: AdmissionsMovieYears,
                        meta: manageSettingsMeta,
                    },
                    {
                        path: 'movie/year/:year(\\d{4})',
                        name: 'AdmissionsMovieYear',
                        component: AdmissionsMovieYear,
                        props: true,
                        meta: manageSettingsMeta,
                    },
                    {
                        path: 'movie/:movixId(\\d+)',
                        name: 'AdmissionsMovie',
                        component: AdmissionsMovie,
                        props: true,
                        meta: manageSettingsMeta,
                    },
                    {
                        path: 'sources',
                        name: 'AdmissionsSources',
                        component: AdmissionsSources,
                        meta: manageSettingsMeta,
                    },
                    {
                        path: 'sources/:file',
                        name: 'AdmissionsSource',
                        component: AdmissionsSource,
                        props: true,
                        meta: manageSettingsMeta,
                    },
                    {
                        path: 'sync',
                        name: 'AdmissionsSync',
                        component: AdmissionsSync,
                        meta: manageSettingsMeta,
                    },
                ],
            },
            {
                path: '/history',
                component: History,
                children: [
                    {
                        path: '',
                        redirect: '/history/search',
                    },
                    {
                        path: 'search',
                        name: 'HistorySearch',
                        component: HistorySearch,
                        meta: manageSettingsMeta,
                    },
                    {
                        path: ':movixId(\\d+)',
                        name: 'HistoryDetail',
                        component: HistoryDetail,
                        props: true,
                        meta: manageSettingsMeta,
                    },
                    {
                        path: ':movixId(\\d+)/month',
                        name: 'HistoryMonthly',
                        component: HistoryMonthly,
                        props: true,
                        meta: manageSettingsMeta,
                    },
                    {
                        path: ':movixId(\\d+)/month/:month/:mode(day|site)',
                        name: 'HistoryMonthDetail',
                        component: HistoryMonthDetail,
                        props: true,
                        meta: manageSettingsMeta,
                    },
                ],
            },
            {
                path: '/admin',
                component: Admin,
                children: [
                    {
                        path: '',
                        name: 'Settings',
                        component: Settings,
                        alias: ['/admin'],
                        meta: manageSettingsMeta,
                    },
                    {
                        path: '/admin/logs',
                        name: 'Logs',
                        component: Logs,
                        meta: manageSettingsMeta,
                    },
                ],
            },
            {
                path: '/profile',
                name: 'Profile',
                component: Profile,
            },
            {
                path: '/login',
                name: 'Login',
                component: Login
            }
        ]
    });

// a global mixin that calls `asyncData` when a route component's params change
/*Vue.mixin({
    beforeRouteUpdate (to, from, next) {
        const { asyncData } = this.$options;
        if (asyncData) {
            asyncData({
                store: this.$store,
                route: to
            }).then(next).catch(next)
        } else {
            next()
        }
    }
});*/

router.beforeResolve((to, from, next) => {
    const matched = router.getMatchedComponents(to);
    const prevMatched = router.getMatchedComponents(from);
    let diffed = false;
    const activated = matched.filter((c, i) => {
        return diffed || (diffed = (prevMatched[i] !== c))
    });
    const asyncDataHooks = activated.map(c => c.asyncData).filter(_ => _);

    if (!asyncDataHooks.length) {
        return next()
    }

    Vue.prototype.$bar.start();
    Promise.all(asyncDataHooks.map(hook => hook({ store, route: to })))
        .then(() => {
            Vue.prototype.$bar.finish();
            next()
        })
        .catch(next)
});

export default router;
